module.exports = __webpack_public_path__ + "img/Platform.a5d977c6.png";